module.exports = __webpack_public_path__ + "img/pic_16.239d11b6.jpg";